/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscordPresenceSessionBody
 */
export interface DiscordPresenceSessionBody {
    /**
     * The observed member's Discord id.
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    discordId: string;
    /**
     * Shared relay bot token (validated against DISCORD_BOT_RELAY_TOKEN by discordBotAuthentication).
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    botToken: string;
    /**
     * Raw Discord activity platform ("xbox" | "ps4" | "ps5" | "playstation").
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    platform: string;
    /**
     * Discord detectable-games application id for the title.
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    applicationId: string;
    /**
     * Game name reported by Discord Rich Presence.
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    gameName: string;
    /**
     * Discord activity timestamps.start (ms), when present.
     * @type {number}
     * @memberof DiscordPresenceSessionBody
     */
    startMs?: number;
    /**
     * The presence transition being forwarded.
     * @type {string}
     * @memberof DiscordPresenceSessionBody
     */
    event: DiscordPresenceSessionBodyEventEnum;
}


/**
 * @export
 */
export const DiscordPresenceSessionBodyEventEnum = {
    start: 'start',
    heartbeat: 'heartbeat',
    stop: 'stop'
} as const;
export type DiscordPresenceSessionBodyEventEnum = typeof DiscordPresenceSessionBodyEventEnum[keyof typeof DiscordPresenceSessionBodyEventEnum];


/**
 * Check if a given object implements the DiscordPresenceSessionBody interface.
 */
export function instanceOfDiscordPresenceSessionBody(value: object): value is DiscordPresenceSessionBody {
    if (!('discordId' in value) || value['discordId'] === undefined) return false;
    if (!('botToken' in value) || value['botToken'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('applicationId' in value) || value['applicationId'] === undefined) return false;
    if (!('gameName' in value) || value['gameName'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function DiscordPresenceSessionBodyFromJSON(json: any): DiscordPresenceSessionBody {
    return DiscordPresenceSessionBodyFromJSONTyped(json, false);
}

export function DiscordPresenceSessionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordPresenceSessionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'discordId': json['discordId'],
        'botToken': json['botToken'],
        'platform': json['platform'],
        'applicationId': json['applicationId'],
        'gameName': json['gameName'],
        'startMs': json['startMs'] == null ? undefined : json['startMs'],
        'event': json['event'],
    };
}

export function DiscordPresenceSessionBodyToJSON(json: any): DiscordPresenceSessionBody {
    return DiscordPresenceSessionBodyToJSONTyped(json, false);
}

export function DiscordPresenceSessionBodyToJSONTyped(value?: DiscordPresenceSessionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discordId': value['discordId'],
        'botToken': value['botToken'],
        'platform': value['platform'],
        'applicationId': value['applicationId'],
        'gameName': value['gameName'],
        'startMs': value['startMs'],
        'event': value['event'],
    };
}

